import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
  background: ${themeColor('background.primary')};
  border: 1px solid ${themeColor('divider.primary')};
  border-radius: 8px;
  padding: 12px 16px;
`;

export const Caption = styled.span`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: ${themeColor('element.secondary')};
  white-space: nowrap;
`;

export const Counter = styled.span`
  margin-left: auto;
  font-size: 12px;
  color: ${themeColor('element.secondary')};
  white-space: nowrap;
`;

export const OptionPeriod = styled.span`
  margin-left: 6px;
  font-size: 12px;
  font-weight: 400;
  color: ${themeColor('element.secondary')};
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
`;
